/**
 * Visibility contract for the "Clear/Disconnect Stripe account" button
 * on Settings -> Stripe Connect.
 *
 * Show whenever an account_id is on file (something to clear),
 * independent of error / onboarded / connected state. Operators must
 * be able to reset from any branch — including the red error
 * diagnostic card when the per-facility key now points at the wrong
 * Stripe account.
 *
 * Server-side MANAGE_MERCHANT_CONFIG still enforces auth on the
 * POST /api/facilities/{facility_id}/stripe/disconnect endpoint.
 *
 * Lives in utils/ (not inline in StripeConnect.js) so jest can import
 * it for smoke tests without the page's react-router-dom imports
 * coming along for the ride.
 */
export const shouldShowDisconnectButton = (status) =>
  Boolean(status && status.account_id);
